import React from 'react';
import ItechForeignAssetsHome from './itechAssetsHome';
import ItechAssetsAccordin from './itechAssetsAccordin';

export default function ItechForeignAssets() {
    return (
        <div>
            <ItechForeignAssetsHome />
            <ItechAssetsAccordin />
        </div>
    );
}
